function Checkout() {
  return <div>Checkout</div>;
}
export default Checkout;
